const routes = [
  // {
  //     path: "/10/zjd",
  //     children: [
  //         {
  //             path: "10_20250609kh",
  //             component: () => import("@/views/10/zjd/20250609/index.vue"),
  //             meta: {
  //                 sign: "10_20250609kh",
  //             },
  //         }
  //     ],
  // },
];

export default routes;
